module.exports = __webpack_public_path__ + "img/leather.333a4961.png";